module.exports = __webpack_public_path__ + "static/media/modon.3a83c217.jpg";